
export default {
  data: () => ({
    isCalendlyActive: false,
  }),

  methods: {
    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
        this.$refs.calendly?.activeCalendly();
      });
    },
  },
};
